import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";

// assets
import arrowIcon from "../../assets/previous_icon.png";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import CustomCheckbox from "../../components/CustomCheckbox";

const OrderListWithInput = ({
  data,
  selectedColors,
  onColorSelect,
  measuringUnit,
  currency,
  onInputChange,
  allSelectedRulers,
}) => {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  const [collapsed, setCollapsed] = useState({});

  /* HANDLER FUNCTIONS */
  const handleCheckboxChange = (fabricCode, colorCode) => {
    onColorSelect(
      fabricCode,
      colorCode,
      !selectedColors[fabricCode]?.[colorCode]
    );
  };

  const toggleCollapse = (fabricCode) => {
    setCollapsed((prev) => ({
      ...prev,
      [fabricCode]: !prev[fabricCode],
    }));
  };

  // Find values from allSelectedRulers
  const getInputValue = (fabricCode, colorCode, field) => {
    const ruler = allSelectedRulers.find((r) => r.code === fabricCode);
    if (!ruler) return "";

    const color = ruler.colors.find((c) => c.colorCode === colorCode);
    if (!color) return "";

    return color[field] || "";
  };

  const handleInputValueChange = (fabricCode, colorCode, field, value) => {
    console.log(value);
    if (onInputChange) {
      onInputChange(fabricCode, colorCode, field, value);
    }
  };

  /* USEEFECT */
  useEffect(() => {
    const initialCollapsed = {};
    data.forEach((fabric) => {
      initialCollapsed[fabric.code] = true;
    });
    setCollapsed(initialCollapsed);
  }, [data]);

  return (
    <div
      className="c-fabric-table o-column o-column--gap-size_400 u-margin u-margin--bottom_700"
      dir={currentDirection}
    >
      {data.map((fabric) => (
        <div key={fabric.code} className="c-fabric-block">
          <div
            className="c-fabric-header"
            onClick={() => toggleCollapse(fabric.code)}
          >
            <span className="c-collapse-icon" style={{ cursor: "pointer" }}>
              <img
                src={arrowIcon}
                alt="Collapse"
                style={{
                  width: 16,
                  transform: collapsed[fabric.code]
                    ? "rotate(0deg)"
                    : "rotate(-90deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </span>

            <span className="c-fabric-code">الكود: {fabric.code}</span>
          </div>

          {!collapsed[fabric.code] && (
            <table className="c-fabric-inner-table">
              <thead>
                <tr>
                  <th>{t("choose")}</th>
                  <th>{t("colorCode")}</th>
                  <th>{t("colorName")}</th>
                  <th>{t("quantity")}</th>
                  <th>{t("price")}</th>
                </tr>
              </thead>
              <tbody>
                {fabric.colors.map((color) => (
                  <tr key={color.colorCode}>
                    <td>
                      <CustomCheckbox
                        checked={
                          selectedColors[fabric.code]?.[color.colorCode] ||
                          false
                        }
                        onChange={() =>
                          handleCheckboxChange(fabric.code, color.colorCode)
                        }
                      />
                    </td>
                    <td>{color.colorCode}</td>
                    <td>{color.colorName}</td>
                    <td>
                      <CustomInputWithUnit
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "quantity"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "quantity",
                            e.target.value
                          )
                        }
                        unit={t(measuringUnit.title)}
                      />
                    </td>
                    <td>
                      <CustomInputWithUnit
                        type="text"
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "price"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "price",
                            e.target.value
                          )
                        }
                        unit={t(currency.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
};

export default OrderListWithInput;
